//images
import hero1 from "./images/hero_3.jpg";
import profile from "./images/profile.png";

//components
import { ButtonPrimary, ButtonOutline } from "./Button";
import ParticlePortrait from "./Particleportrait";

function Hero() {
  return (
    <section id="home" className="pt-18 lg:pt-24">
      <div className="container lg:grid lg:grid-cols-2 items-center lg:gap-10">
        <div>
          <div className="flex items-center gap-3">
            <figure className="img-box w-9 h-9 rounded-lg">
              <img
                src={profile}
                width={40}
                height={40}
                alt="Bemnet Ayalew portrait"
                className="img-cover"
              />
            </figure>

            <div className="flex items-center gap-1.5 text-zinc-400 text-sm tracking-wide">
              <span className="relative w-2 h-2 rounded-full bg-emerald-400">
                <span className="absolute inset-0 rounded-full bg-emerald-400 animate-ping"></span>
              </span>
              Available for work
            </div>
          </div>

          <h2 className="headline-1 max-w-[15ch sm:max-w-[20ch] lg:max-w-[15ch] mt-5 mb-8 lg:mb-10">
            Full Stack Software Developer
          </h2>
          <p className="text-zinc-400 mb-8 lg:mb-10">
            I am a full stack software developer with a passion for building web
            and mobile applications. I am a quick learner and I am always
            looking for new challenges.
          </p>

          <div className="flex items-center gap-3">
            <ButtonPrimary
              label="MY RESUME"
              icon="link"
              target="_blank"
              href="https://drive.google.com/file/d/10BKkQYO1p43AF4kPGtuGxOx6fyJeJ23e/view?usp=sharing"
              // download="BEMNET_AYALEW_RESUME.pdf"
            />

            <ButtonOutline
              target="_blank"
              href="mailto:getbemnet21@gmail.com"
              label="Hire Me"
              icon="email"
            />
          </div>
        </div>

        <div className="hidden lg:block">
          <figure className="w-full max-w-[520px] ml-auto">
            <ParticlePortrait
              imageSrc={hero1}
              width={520}
              height={600}
              className="w-full h-auto"
            />
          </figure>
        </div>
      </div>
    </section>
  );
}

export default Hero;
